import { Avatar, Box, Toolbar, Typography, AppBar } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import logo1 from "../../../assetes/logo copy.png";
import "./navbar.css";
import Typed from "typed.js";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [index, setindex] = useState(0);
  const nameEl = useRef(null);
  useEffect(() => {
    const typedName = new Typed(nameEl.current, {
      strings: [" IMA Ind.Group "],
      typeSpeed: 110,
      backSpeed: 80,
      backDelay: 50,
      showCursor: false,
    });
    const stringTransition = setInterval(() => {
      setindex((index) => index + 1);
    }, 3000);

    return () => {
      typedName.destroy();
      clearInterval(stringTransition);
    };
  }, []);

  return (
    <>
      <Box sx={{ flexGrow: 3 }}>
        <AppBar position="sticky" sx={{ backgroundColor: "whitesmoke" }}>
          <Toolbar>
            <Avatar
              variant="square"
              alt="IMA"
              src={logo1}
              sx={{ width: 130, height: 130, mr: 45 }}
            />
            <Typography
              className="title"
              ref={nameEl}
              variant="h6"
              color="black"
              sx={{
                display: "flex",
                fontFamily: "roboto",
                fontSize: "1.8rem",
                flexDirection: "row",
                justifyContent: "start",
              }}
            ></Typography>
            <Link
              className="Fa-bt"
              to="/"
              component="Button"
              style={{
                textDecoration: "none",
                padding: "5px 7px",
                fontSize: "1.5rem",
                margin: "1px 5px",
                display: "flex",
                float: "right",
              }}
            >
              <Typography sx={{ fontSize: 25 }}>Fa</Typography>
            </Link>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};
export default NavBar;
